<template>
  <div
    class="row mx-auto mb-3"
    v-if="hasAlternatives"
  >
    <CustomCallout
      :key="`alternative-callout-${i}`"
      v-for="(alternative, i) in item.alternatives"
      :has-border="false" class="mx-auto row col-12" class-main="col-12 bg-white mb-3"
    >
      <div class="mx-auto row pl-lg-3 pb-lg-3 pr-lg-3 pt-lg-1">
        <div class="col-12">
          <SearchReadOnly
            :readonly="readonly"
            :item="mappedAlternative(item, alternative)"
            :academic-year-id="academicYearId"
            :region="region"
            :municipality="municipality"
            :select-municipality="selectMunicipality"
            :tap-request-id="tapRequestId"
            @edit="$emit('edit')"
            @remove="$emit('remove')"
          />
        </div>
      </div>
    </CustomCallout>
  </div>
</template>

<script>
import SearchReadOnly from './SearchReadOnly';
import SchoolAlternativeItem from './SchoolAlternativeItem';
import CustomCallout from 'custom-callout';

export default {
  name: 'SchoolRecommendationFormReadOnly',
  components: {
    SearchReadOnly,
    SchoolAlternativeItem,
    CustomCallout,
  },
  props: {
    academicYearId: { type: [Number, String], required: true, default: null },
    region: { type: Object, default: null },
    municipality: { type: Object, default: null },
    selectMunicipality: { type: Boolean, default: true },
    /* SchoolRecommendationModel */
    item: { type: Object, default: null },
    readonly: { type: Boolean, default: false },
    tapRequestId: { type: [Number, String], required: true, default: null },
  },
  computed: {
    hasAlternatives() {
      return this.item?.alternatives?.length;
    },
    mappedAlternative() {
      return (item, alternative) =>({
        id: item.id,
        tapRequestTypeId: item.tapRequestTypeId,
        region: item.region,
        municipality: item.municipality,
        school: item.school,
        alternative,
        reason: item.reason,
      })
    },
  },
};
</script>
